import React, { useEffect, useState } from 'react';
import { Description, Link } from './styles';
import Modal from '../index';
import InputToken from '../../InputToken';
import Button from '../../Button';
import { formatTelephone } from '../../../services/utils/formatTELandCEP';
import { useDispatch, useSelector } from 'react-redux';
import {
  generateNewTelephone,
  tokenSentTimeAction,
  validateNewTelephone,
} from '../../../store/auth/actions';
import Toast from '../../../components/Toast';
import { toast } from 'react-toastify';
import { navigationUrl } from '../../../store/analytic/actions';
import moment from 'moment';

interface IClose {
  telephone: string;
  handlerClose: () => void;
  optionChecked: TypeOptions;
  setAutoFocus: Function;
}

type TypeOptions = {
  whatsApp: boolean;
  sms: boolean;
};

function ValidateModal({
  telephone,
  handlerClose,
  optionChecked,
  setAutoFocus,
}: IClose) {
  const dispatch = useDispatch();
  const [token, setToken] = useState<string>('');
  const [error, setError] = useState(false);
  const telTokenError = useSelector(
    (state: ApplicationState) => state.auth.telTokenError
  );

  useEffect(() => {
    dispatch(tokenSentTimeAction(moment().toDate()));
    dispatch(
      navigationUrl.request({
        action: '/confirmarCelular',
      })
    );
  }, [dispatch]);

  const handlerDigit = (value: string) => {
    const digits = value.replace(/\s/g, '');
    setToken(digits);
  };

  const submit = () => {
    if (token.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1').length !== 6) {
      return toast.error(
        <Toast
          title={'Credencial inválida!'}
          description={'O token não é válido!'}
        />
      );
    }
    const ddd = telephone.slice(0, 2);
    const phone = telephone.slice(2);
    dispatch(validateNewTelephone.request({ token, ddd, phone }));
    handlerClose();
  };

  const generateTokenAgain = () => {
    dispatch(tokenSentTimeAction(moment().toDate()));
    const optionSelected = optionChecked.whatsApp
      ? 'whatsapp'
      : optionChecked.sms
      ? 'sms'
      : '';

    if (optionSelected) {
      dispatch(
        generateNewTelephone.request({
          type: optionSelected,
          telephone: telephone,
        })
      );
      dispatch(
        navigationUrl.request({
          action: '/reenviaTokenCelular',
        })
      );
    }
  };

  const getOptionChecked = () => (optionChecked.whatsApp ? 'WhatsApp' : 'SMS');

  const changeTelephone = () => {
    handlerClose();
    setAutoFocus('FOCUS_INPUT_PHONE');
  };

  return (
    <Modal
      title={'Validar celular'}
      width={'464px'}
      handlerClose={handlerClose}
    >
      <Description>
        {`Nós enviamos um token para o ${getOptionChecked()} do celular cadastrado +55${' '}
        ${formatTelephone(telephone)}. Verifique o número em seu celular e
        informe no campo abaixo:`}
      </Description>
      <InputToken
        value={token}
        error={telTokenError}
        bottom={'24px'}
        countDown={true}
        change={(e: React.ChangeEvent<HTMLInputElement>) =>
          handlerDigit(e.target.value)
        }
        onClickButtonExpired={generateTokenAgain}
        setError={setError}
      />
      <Button
        height={60}
        color={!error ? 'primary' : 'error'}
        block={true}
        transform={true}
        fontSize='16'
        borderRadios='16'
        onClick={submit}
      >
        Confirmar
      </Button>
      <Link top={32} onClick={generateTokenAgain} error={error}>
        Não recebeu o código?
      </Link>
      <Link onClick={() => changeTelephone()} error={error}>
        Alterar número de telefone
      </Link>
    </Modal>
  );
}

export default ValidateModal;
